module.exports = __webpack_public_path__ + "img/paso-2.18222895.png";